// Libs
import classNames from 'classnames/bind';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
// Components, Layouts, Pages
// Others
import { INotification } from '~/utils/interface/notification';
import { BusinessModelEnum, NotificationStatusEnum } from '~/utils/enum/common';
import { EMPTY_STRING } from '~/utils/constants/common';
// Styles, images, icons
import styles from './NotificationItem.module.scss';
import { icons } from '~/assets';

type Props = { data: INotification; onClick?: (notification: INotification) => void };

const cx = classNames.bind(styles);

const NotificationItem = (props: Props) => {
  //#region Destructuring Props
  const { data, onClick } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/notification']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleNotificationSelected = () => {
    onClick && onClick(data);
  };

  const renderNotificationTitle = () => {
    switch (data?.businessType) {
      case BusinessModelEnum.JOB:
        return t('notification_job_title', { data: data?.businessId });

      case BusinessModelEnum.INVENTORY:
        return t('notification_inventory_title', { data: data?.businessId });

      case BusinessModelEnum.INVOICE:
        return t('notification_invoice_title', { data: data?.businessId });

      case BusinessModelEnum.CHANGE_STATUS_ESTIMATE:
        return t('notification_change_status_estimate_title', { data: data?.businessId });

      case BusinessModelEnum.ESTIMATE:
        return t('notification_estimate_title', { data: data?.businessId });

      case BusinessModelEnum.CHANGE_STATUS_JOB:
        return t('notification_change_status_job_title', { data: data?.businessId });

      default:
        return EMPTY_STRING;
    }
  };

  const renderNotificationIcon = () => {
    switch (data?.businessType) {
      case BusinessModelEnum.JOB:
        return icons.menuIconJobsInactive;

      case BusinessModelEnum.INVENTORY:
        return icons.menuIconCategoryInactive;

      case BusinessModelEnum.INVOICE:
        return icons.menuIconInvoiceInactive;

      case BusinessModelEnum.CHANGE_STATUS_ESTIMATE:
        return icons.menuIconEstimateInactive;

      case BusinessModelEnum.ESTIMATE:
        return icons.menuIconEstimateInactive;

      case BusinessModelEnum.CHANGE_STATUS_JOB:
        return icons.menuIconJobsInactive;

      default:
        return EMPTY_STRING;
    }
  };

  const renderNotificationDescription = () => {
    switch (data?.businessType) {
      case BusinessModelEnum.JOB:
        return t('notification_job_desc');

      case BusinessModelEnum.INVENTORY:
        return t('notification_inventory_desc');

      case BusinessModelEnum.INVOICE:
        return t('notification_invoice_desc');

      case BusinessModelEnum.CHANGE_STATUS_ESTIMATE:
        return t('notification_change_status_estimate_desc');

      case BusinessModelEnum.CHANGE_STATUS_JOB:
        return t('notification_change_status_job_desc');

      case BusinessModelEnum.ESTIMATE:
        return t('notification_estimate_desc');

      default:
        return EMPTY_STRING;
    }
  };
  //#endregion Handle Function

  return (
    <Stack
      component={'div'}
      className={cx('container', { unread: data?.status === NotificationStatusEnum.UNREAD })}
      direction={'row'}
      gap={'12px'}
      onClick={handleNotificationSelected}
    >
      <Box component={'div'} className={cx('notificationIcon')}>
        <img src={renderNotificationIcon()} alt={t('common_alt_img', { ns: 'common/base' })} />
      </Box>

      <Box component={'div'} className={cx('notificationContent')}>
        <Stack
          component={'div'}
          className={cx('titleGroup')}
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          gap={'12px'}
        >
          <Typography component={'p'} className={cx('title')}>
            {renderNotificationTitle()}
          </Typography>

          <Typography component={'p'} className={cx('time')}>
            {moment(data?.createdAt).fromNow()}
          </Typography>
        </Stack>

        <Typography component={'p'} className={cx('desc')}>
          {renderNotificationDescription()}
        </Typography>
      </Box>
    </Stack>
  );
};

export default NotificationItem;
